<section *ngIf="lesson">
  <div class="pupil-task" [ngClass]="getCardCssClass(card)">
    <div class="pupil-task__pupil">
      <div *ngIf="pupil" class="pupil-task__pupil__info" [class.normal]="!card?.box.smart_sprints.length">
        <span *ngIf="card?.box.smart_sprints.length" class="pupil-task__pupil__info__sprint_logo"></span>
        <span *ngIf="card?.box.smart_sprints.length" class="pupil-task__pupil__info__timer">
          <span class="pupil-task__pupil__info__timer__wrapper">
            {{ tasksTimerStr }}
          </span>
        </span>
        <span class="pupil-task__pupil__info__photo">
          <app-privilege-icon [student]="pupil" [lesson]="lesson"></app-privilege-icon>
        </span>
        <span class="pupil-task__pupil__info__name">
          <b>{{ pupil?.surname }} {{ pupil?.name }}</b>
        </span>
      </div>
      <div *ngIf="(selectedExercise && selectedExercise.type != magic_box) || resultPressed" class="pupil-task__pupil__exercise-result">
        <div class="card_number_box" [class.incorrect-box]="!allCorrect">
          <div class="card_number_box__title">
            <span class="card_number_box__title__number">{{ card?.box.title }}</span>
          </div>
          <div class="card_number">
            № <span>{{ card?.card_number }}</span>
          </div>
          <div class="kairos_bonus" *ngIf="hasKairosBonus">
            <img
              src="/assets/images/privilege_icons/kairos_bonus_gradient_icon.png"
              alt="Кайрос бонус">
          </div>
          <!-- <div class="magnifier" *ngIf="resultPressed">
            <div (click)="showResultsModal()">
              <i class="fa fa-search-plus" aria-hidden="true"></i>
            </div>
          </div> -->
        </div>

        <div *ngIf="[calculation, sequence, insert].includes(card?.exercises[0].type)"
              class="task-list type1" [class.calculation]="card?.exercises[0].type === calculation || card?.exercises[0].type === insert">
          <table class="aside_exercise_calculation">
            <tbody>
              <tr class="complete" *ngFor="let exercise of card?.exercises; let exeIndex = index">
                <td width="40px" class="number text-right">{{ exeIndex + 1 }}.</td>
                <td class="text-left">
                  <span (click)="selectExercise(exercise)">
                    <ng-katex *ngIf="isKatexFormat(exercise)" class="katex text" [equation]="exercise.text"></ng-katex>
                    <ng-katex-paragraph *ngIf="!isKatexFormat(exercise)" [paragraph]="exercise.text|exerciseFormat"></ng-katex-paragraph>
                  </span>
                  <span [class]="getClass(exercise.id)">
                    {{ getStudentAnswer(exercise.id) }}
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <ng-container *ngIf="[puzzleTask, puzzleExample].includes(card?.exercises[0].type)">
          <section class="pupil-task__pupil__exercise-result__puzzle">
            <span *ngIf="card?.card_text" class="pupil-task__pupil__exercise-result__puzzle__card-title">
              {{ card.card_text }}
            </span>
            <span *ngFor="let exercise of card?.exercises; let i = index" class="pupil-task__pupil__exercise-result__puzzle__card-exercise">
              <div (click)="selectExercise(exercise)" [class.selected-exercise]="selectedExerciseIndex === i">
                <app-exercise-puzzle
                  [exercise]="exercise"
                  [index]="i"
                  [viewType]="'student_left'"
                  [isFinishCard]="resultPressed"
                  [correctOrNot]="checkCorrectAnswer(exercise?.id)"
                  [activeCard]="card">
                </app-exercise-puzzle>
              </div>
            </span>
          </section>
        </ng-container>
        <div class="task-list type2" *ngIf="card?.exercises[0].type === task">
          <div class="task-list-item">
            <p class="task-title text-center" *ngFor="let exercise of card?.exercises; let exeIndex = index">
              <span class="question" (click)="selectExercise(exercise)" style="cursor: pointer;"> Задача {{ exeIndex + 1 }}</span>
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="pupil-task__exercises">
      <div *ngIf="timerActivated" class="pupil-task__time-countdowner">
          Урок завершен. У вас осталось <b>{{ timerCountVal }}</b> минут что бы ввести ответ.
      </div>
      <div *ngIf="selectedExercise && (selectedExercise.type == calculation || selectedExercise.type == sequence || selectedExercise.type == insert)">
        <app-pupil-exercise
          [answerString]="answerString"
          [exercise]="selectedExercise"
          [selectedExerciseIndex]="selectedExerciseIndex"
          [studentId]="pupil?.id"
          [cardId]="card?.id"
          [sequenceInstruction]="sequenceInstruction"
          [isFinishCard]="resultPressed"
          (answered)="getAnswers($event)"
          (exerciseCompleted)="exerciseCompleted($event)"
          (exerciseCorrect)="exerciseCorrect($event)"
        ></app-pupil-exercise>
      </div>
      <div *ngIf="selectedExercise && selectedExercise.type == task">
        <app-pupil-task-exercise
          [exercise]="selectedExercise"
          [selectedExerciseIndex]="selectedExerciseIndex"
          [studentId]="pupil?.id"
          [cardId]="card?.id"
          [isFinishCard]="resultPressed"
          (answered)="getAnswers($event)"
          (exerciseCompleted)="exerciseCompleted($event)"
          (exerciseCorrect)="exerciseCorrect($event)"
        ></app-pupil-task-exercise>
      </div>
      <div *ngIf="selectedExercise && selectedExercise.type == logic">
        <app-pupil-task-exercise
          [exercise]="selectedExercise"
          [selectedExerciseIndex]="selectedExerciseIndex"
          [studentId]="pupil?.id"
          [cardId]="card?.id"
          [isFinishCard]="resultPressed"
          (answered)="getAnswers($event)"
          (exerciseCompleted)="exerciseCompleted($event)"
          (exerciseCorrect)="exerciseCorrect($event)"
        ></app-pupil-task-exercise>
      </div>
      <div *ngIf="selectedExercise && selectedExercise.type == magic_box">
        <app-pupil-magic-box-exercise
          [exercise]="selectedExercise"
          [selectedExerciseIndex]="selectedExerciseIndex"
          [studentId]="pupil?.id"
          [cardId]="card?.id"
          [card]="card"
          [isFinishCard]="resultPressed"
          (answered)="getAnswers($event)"
          (exerciseCompleted)="exerciseCompleted($event)"
          (exerciseCorrect)="exerciseCorrect($event)"
        ></app-pupil-magic-box-exercise>
      </div>
      <ng-container *ngIf="[puzzleTask, puzzleExample].includes(card?.exercises[0].type)">
        <section class="pupil-task__pupil__exercise-result__puzzle">
          <span *ngIf="card?.card_text && selectedExercise" class="pupil-task__pupil__exercise-result__puzzle__card-title">
            {{ card.card_text }}
          </span>
          <app-exercise-puzzle
            [exercise]="selectedExercise"
            [viewType]="'student_right'"
            [studentId]="studentId"
            [isFinishCard]="resultPressed"
            [correctOrNot]="checkCorrectAnswer(selectedExercise?.id)"
            (answered)="checkAnswer($event)"
            (exerciseCompleted)="exerciseCompleted($event)"
            [activeCard]="card">
          </app-exercise-puzzle>
        </section>
      </ng-container>
      <div *ngIf="resultPressed">
        <span *ngIf="card?.box.smart_sprints.length" class="result-pressed__with-timer">
          <span class="result-pressed__with-timer__title">
            <ul>
              <li>минут</li>
              <li>секунд</li>
            </ul>
          </span>
          <span class="result-pressed__with-timer__time">
            <p >{{ tasksTimerStr }}</p>
          </span>
        </span>
        <!-- с персонажем -->
        <div *ngIf="selectCharacter">
          <div class="character-message">
            <span class="without-risk" *ngIf="!selectCharacter.is_risk"><img src="{{ selectCharacter.image }}"></span>
            <span class="text-right message">
              <!-- если ответы верны -->
              <img *ngIf="selectCharacter.is_risk && allCorrect" src="/assets/images/ОКно_2.png" alt="">
              <img *ngIf="!selectCharacter.is_risk && allCorrect" src="/assets/images/ОКно.png" alt="">

              <!-- если ответы неверны -->
              <img *ngIf="selectCharacter.is_risk && !allCorrect" src="/assets/images/ОКно2.png" alt="">
              <img *ngIf="!selectCharacter.is_risk && !allCorrect" src="/assets/images/ОКно2_2.png" alt="">
              <div [ngClass]="{'message_text_left': !selectCharacter.is_risk, 'message_text_right': selectCharacter.is_risk}" *ngIf="allCorrect">
                Молодец!
              </div>
              <div [ngClass]="{'message_text__false_left': !selectCharacter.is_risk, 'message_text__false_right': selectCharacter.is_risk}" *ngIf="!allCorrect">
                <h3>Ой!</h3>
                <h3 *ngIf="card?.exercises.length - correctAnswersCount == 1">
                  {{ card?.exercises.length - correctAnswersCount }} ошибка</h3>
                <h3 *ngIf="card?.exercises.length - correctAnswersCount > 1 && card?.exercises.length - correctAnswersCount <= 4">
                  {{ card?.exercises.length - correctAnswersCount }} ошибки</h3>
                <h3 *ngIf="card?.exercises.length - correctAnswersCount > 4">
                  {{ card?.exercises.length - correctAnswersCount }} ошибок</h3>
              </div>
            </span>
            <span class="with-risk" *ngIf="selectCharacter.is_risk"><img src="{{ selectCharacter.image }}"></span>
          </div>
        </div>

        <!-- без перснонажа -->
        <div *ngIf="!selectCharacter">
          <!-- без перснонажа если решенно неверно -->
          <div class="row" *ngIf="allCorrect == false">
            <div class="col top">
              <h2 class="assessment bluelight_txt text-center">
                {{ greeting?.text }}
              </h2>
            </div>
          </div>
          <div class="row" *ngIf="allCorrect == false">
            <div class="col mid">
              <h4 class="bluedark_txt text-center">Правильно решены</h4>
              <h4 class="assessment bluedark_txt text-center">{{ correctAnswersCount }} из {{ card?.exercises.length }} заданий</h4>

              <img class="nika-right" src="/assets/images/nika-blue.png" alt="">
            </div>
          </div>

          <!-- без перснонажа если решенно верно -->
          <div class="row text-center" *ngIf="allCorrect">
            <div class="col top">
              <div *ngIf="hasKairosBonus else noKairos;">
                <h3 class="bluedark_txt kairos">Отлично!</h3>
                <h4 class="green_txt well-done-msg kairos">Кайрос-бонус!</h4>
              </div>
              <ng-template #noKairos>
                <h3 class="bluedark_txt">Все решено верно</h3>
                <h4 class="green_txt well-done-msg">Молодец!</h4>
              </ng-template>
            </div>
          </div>
        </div>

        <!-- вознаграждение когда ответы верны -->
        <div class="row" *ngIf="allCorrect">
          <div class="col mid">
            <div class="reward">
              <div class="reward__kairos" *ngIf="hasKairosBonus">
                <div class="reward__kairos__wrapper">
                  <h4 class="total_reward">{{ totalReward }}</h4>
                  <h4 class="currency">
                    {{ declensionOfNumerals(totalReward) }}
                  </h4>
                  <img class="sun_wrapper" src="/assets/images/kairos_sun.png" alt="">
                </div>
                <div class="character">
                  <img src="/assets/images/privileges/kairos_character.png" alt="Кайрос">
                </div>
              </div>
              <div class="reward__default" *ngIf="!hasKairosBonus">
                <h4 class="assessment green_txt text-center total-reward">{{ totalReward }} </h4>
                <h4 class="assessment green_txt text-center">
                  {{ declensionOfNumerals(totalReward) }}
                </h4>
                <img
                  *ngIf="!selectCharacter"
                  class="nika-right" src="/assets/images/nika-green.png"
                  alt="">
              </div>
            </div>
          </div>
        </div>
        <!-- вознаграждение когда ответы не верны -->
        <div [ngClass]="{'risk-character-reward_false': selectCharacter?.is_risk}" *ngIf="!allCorrect">
          <div class="col mid">
            <h4 class="assessment blue_text text-center total-reward" *ngIf="!selectCharacter?.is_risk">0</h4>
            <h4 class="assessment red_text text-center total-reward"
              *ngIf="selectCharacter?.is_risk">
                {{ cardSettings?.penalty }}
            </h4>
            <h4 class="assessment red_text text-center" *ngIf="selectCharacter?.is_risk">
              {{ declensionOfNumerals(cardSettings?.penalty) }}
            </h4>
            <h4 class="assessment blue_text text-center" *ngIf="!selectCharacter?.is_risk">
              {{ declensionOfNumerals(totalReward) }}
            </h4>
            <div class="fine-message" *ngIf="selectCharacter?.is_risk">
              <span>
                <img src="/assets/images/fine.png" alt="Штраф">
              </span>
              <span class="red_text">Штраф</span>
            </div>
          </div>
        </div>

        <div class="btm">
          <a (click)="getNextCard()" class="next_card" appDisTouchmove>Ещё вариант</a>
          <a (click)="exitClicked()" class="exit_btn" appDisTouchmove>Выйти</a>
        </div>
      </div>
    </div>
  </div>

  <!-- Модалка подтверждения результатов решения -->
  <div class="modal all_right_modal fade" id="all_right_modal" #solvedModal="bs-modal" bsModal [config]="{backdrop: 'static'}">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title text-center">Всё верно?</h4>
        </div>
        <div class="modal-body">
          <div class="row task">
            <div class="col text-center">
              <ul class="task-list-popup">
                <li class="task-list  type1 " *ngFor="let exercise of card?.exercises; let exeIndex = index">
                    <span class="type1 calculation" *ngIf="exercise.type === calculation">
                      <span class="number">{{ exeIndex + 1 }}.</span>
                      <ng-katex-paragraph *ngIf="!isKatexFormat(exercise)" class="question" [paragraph]="exercise.text|exerciseFormat"></ng-katex-paragraph>
                      <ng-katex *ngIf="isKatexFormat(exercise)" class="katex text" [equation]="exercise.text"></ng-katex>
                      <span class="answer" [innerHTML]="getStudentAnswer(exercise.id)"></span>
                    </span>
                    <span class="type1" *ngIf="exercise.type == sequence">
                      <span class="number">{{ exeIndex + 1 }}.</span>
                      <ng-katex-paragraph class="question" [paragraph]="exercise.text|exerciseFormat"></ng-katex-paragraph>
                      <span class="answer" [innerHTML]="getStudentAnswer(exercise.id)"></span>
                    </span>
                    <span class="type2" *ngIf="exercise.type == insert">
                      <span class="number">{{ exeIndex + 1 }}.</span>
                      <ng-katex *ngIf="isKatexFormat(exercise)" class="katex text question" [equation]="exercise.text"></ng-katex>
                      <ng-katex-paragraph *ngIf="!isKatexFormat(exercise)"  class="question" [paragraph]="exercise.text|exerciseFormat"></ng-katex-paragraph>
                      <p class="answer-blue">
                        Ответ: {{getStudentAnswer(exercise.id)}}
                      </p>
                    </span>
                    <div class="type1" *ngIf="exercise.type === puzzleExample || exercise.type === puzzleTask">
                      <span class="number">{{ exeIndex + 1 }}.</span>
                      <p class="question">{{exercise.hint}}</p>
                      <div><img src="{{exercise.img}}" alt="" /></div>
                      <p class="answer-blue">
                        Ответ: {{getStudentAnswer(exercise.id)}}
                      </p>
                    </div>
                    <span class="type2" *ngIf="exercise.type != calculation && exercise.type != puzzleExample && exercise.type != puzzleTask && exercise.type != sequence && exercise.type !== insert">
                      <div  *ngIf="exercise.type == magic_box">
                        <table *ngIf="getExerciseAnswerForMagicBox(exercise.id)" class="table-magic-box-answers" align="center">
                          <tr *ngFor="let row of getExerciseAnswerForMagicBox(exercise.id)">
                            <td *ngFor="let elem of row">
                              {{ elem }}
                            </td>
                          </tr>
                        </table>
                      </div>
                      <div *ngIf="exercise.type != magic_box">
                        <div class="number" style="width:auto">{{ exeIndex + 1 }}.</div>
                        <ng-katex *ngIf="isKatexFormat(exercise)" [equation]="exercise.text | exerciseFormat:'text'"></ng-katex>
                        <div *ngIf="!isKatexFormat(exercise)" class="text"> {{ exercise.text }}</div>
                        <br>
                        <div class="text" *ngFor="let question of exercise.questions; let queIndex = index">
                          <p class="question">{{ question.text }}</p>
                          <p class="answer">
                            Ответ:
                            <span class="answer-blue">{{ getStudentAnswerForQuestion(exercise.id, question.id) }}</span>
                          </p>
                        </div>
                      </div>
                    </span>
                </li>
              </ul>
            </div>
          </div>
          <div class="row" *ngIf="this.studentAnswers.length > 0 && getExerciseIDWithoutAnswer().length > 0">
            <div class="col">
              <h4>Упражнение без ответа будут защитаны как ошибка!</h4>
            </div>
          </div>

          <div class="action-options">
            <a class="action-options-btn no" data-dismiss="modal" aria-hidden="true" (click)="newLoop()" appDisTouchmove>
              <div class="inner">
                <span>Нет</span>
                <span>исправить</span>
              </div>
            </a>
            <a class="action-options-btn yes" (click)="showResults()" data-dismiss="modal" aria-hidden="true" appDisTouchmove>
              <div class="inner">
                <span>Да</span>
                <span>дальше</span>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Модалка результатов решения варианта -->
  <div class="modal pupil_personal-result-modal fade" id="modalResult" #resultModal="bs-modal" bsModal [config]="{backdrop: 'static'}">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <span class="box">
            <span class="number">{{ card?.box.title }}</span>
          </span>
          <span class="card_number">
            № <span class="number">{{ card?.card_number }}</span>
          </span>
          <span class="modal-cross-icon" (click)="closeResultModal()">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" aria-hidden="true">
              <defs>
                <style>.pupil_modal-close-cls-1,.pupil_modal-close-cls-2{fill:none;}.pupil_modal-close-cls-2{stroke:#ccc;stroke-miterlimit:10;stroke-width:2px;} .modal-cross-icon:hover .pupil_modal-close-cls-2{stroke:#999999;stroke-miterlimit:10;stroke-width:2px;}</style>
              </defs>
              <title></title>
              <g id="Слой_2" data-name="Слой 2">
                <g id="Слой_10" data-name="Слой 10">
                  <rect class="pupil_modal-close-cls-1" width="32" height="32"/>
                  <line class="pupil_modal-close-cls-2" x1="2" y1="2" x2="30" y2="30"/>
                  <line class="pupil_modal-close-cls-2" x1="2" y1="30" x2="30" y2="2"/></g></g>
            </svg>
          </span>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col">
              <div class="task-list type1" *ngIf="card?.exercises[0].type === calculation || card?.exercises[0].type === insert">
                <table>
                  <tbody>
                  <tr *ngFor="let exercise of card?.exercises; let exeIndex = index">
                    <td width="55px" class="number text-right">{{ exeIndex + 1 }}.</td>
                    <td class="text-left task">
                      <ng-katex-paragraph class="question" [paragraph]="exercise.text | exerciseFormat"></ng-katex-paragraph>
                      <span [innerHTML]="getStudentAnswer(exercise.id) " [class]="getClass(exercise.id)"></span>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
              <div class="task-list type1" *ngIf="card?.exercises[0].type === sequence">
                <table>
                  <tbody>
                  <tr *ngFor="let exercise of card?.exercises; let exeIndex = index">
                    <td width="55px" class="number text-right">{{ exeIndex + 1 }}.</td>
                    <td class="text-left task">
                      <ng-katex-paragraph class="question" [paragraph]="exercise.text | exerciseFormat"></ng-katex-paragraph>
                      <span [innerHTML]="getStudentAnswer(exercise.id) " [class]="getClass(exercise.id)"></span>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
              <div class="task-list type1" *ngIf="card?.exercises[0].type === magic_box">
                <div *ngFor="let exercise of card?.exercises; let exeIndex = index">
                  <table *ngIf="getExerciseAnswerForMagicBox(exercise.id)" class="table-magic-box-answers">
                    <tr *ngFor="let row of getExerciseAnswerForMagicBox(exercise.id)">
                      <td *ngFor="let elem of row">
                        {{ elem }}
                      </td>
                    </tr>
                  </table>
                </div>
              </div>
              <div class="task-list type2" *ngIf="card?.exercises[0].type === task || card?.exercises[0].type === logic">
                <div class="task-list-item" *ngFor="let exercise of card?.exercises; let exeIndex = index">
                  <p class="task-title text-center" [ngClass]="getExerciseClass(exercise.id)">
                    Задача {{ exeIndex + 1 }}
                  </p>
                  <p class="condition-task text-left">
                    {{ exercise.text }}
                  </p>

                  <div class="row">
                    <div class="col-8 text-center">
                      <table>
                        <tbody>
                        <tr *ngFor="let question of exercise.questions; let queIndex = index">
                          <td>
                        <tr>
                          <td width="135" class="text-right">
                            Вопрос № {{ queIndex + 1 }}:
                          </td>
                          <td class="question text-left">
                            {{ question.text }}
                          </td>
                        </tr>
                        <tr *ngIf="exercise.type == 'logic'">
                          <td width="135" class="text-right">
                            Ответ: {{ getStudentAnswerForQuestion(exercise.id, question.id) }}
                          </td>
                          <td class="answer text-left">
                            <span *ngFor="let word of exercise.words" [class]="getClassForWord(word)">{{ word }}</span>
                          </td>
                        </tr>
                        <tr *ngIf="exercise.type == 'task'">
                          <td width="135" class="text-right">
                            Ответ:
                          </td>
                          <td class="answer text-left">
                            <span [class]="getClass(exercise.id)">{{ getStudentAnswerForQuestion(exercise.id, question.id) }}</span>
                          </td>
                        </tr>
                        </td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<a class="exit" *ngIf="resultPressed == false" appDisTouchmove (click)="leavePage()">
  <span class="txt">Назад</span>
</a>


<!-- модалка которая уведомляет ученика когда настроек варианта небыло полученно -->
<ng-template #sendAnswerErrorMsg>
  <mat-dialog-content class="error-msg__dialog">
    <p>Ответы не защитаны так как небыло полученно настроек варианта, 
      <br> необходимо проверить интернет и попробовать сново.</p>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-raised-button (click)="closeDialog()">Хорошо</button>
  </mat-dialog-actions>
</ng-template>